import React, { Component } from "react";
import { FaTrash } from 'react-icons/fa';

import { getAssetsInfo, Updateasset } from "../services/userServices";
// import { ColorPickerComponent } from '@syncfusion/ej2-react-inputs';
import '../App.css'
import TopBar from "../components/TopBar";


import { withStyles, } from "@material-ui/core";


import { Input } from '@material-ui/core'

import { createMuiTheme, MuiThemeProvider } from '@material-ui/core'

import { MenuItem } from '@material-ui/core'


import {
    Button
} from 'reactstrap';



import { generateAssetsData } from "../services/userServices";

const theme = createMuiTheme({
    overrides: {
        MuiChip: {
            root: {
                fontSize: "11px",
                color: "#3c4043",
                marginTop: 20,
                height: 25,
                backgroundColor: "rgba(0, 0, 0, 0.10)",
                padding: "3px 5px"
            },
            deleteIcon: {
                width: 14,
                height: 14,
                margin: 0
            },
            label: {
                color: "#3c4043",
                cursor: "pointer",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: "11px",
                margin: "0 6px",
                padding: "1px",
                paddingLeft: 0,
                paddingRight: 0,
                marginRight: 0,
                fontWeight: 600
            }
        }
    },
    typography: {
        useNextVariants: true
    }
});




class AssetsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: '',
            background: '#fff',
            teamName: '',
            teamLogo: '',

            stadiumSeatingImage: '',
            lightShowFile: '',


            teamHex1: '',
            teamHex2: '',
            MyuploadImage: '',
            Add: false


        }
        this.onCreated = this.onCreated.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);


        // this.onCreated = this.onCreated.bind(this);
    }

    /********************************************************************************************************************************8 */
    //sliding of the cards

    slideCards = () => {
        try {
            this.setState({ slideCards: !this.state.slideCards });
        } catch (err) {
            console.log("error at slideCards in dashBoard");
        }
    };
    /**
     * @description:it handles the cards style
     */
    handleCardStyle = () => {
        try {
            this.setState({ cardStyles: !this.state.cardStyles });
        } catch (err) {
            console.log("error at handleCardStyle in dashBoard");
        }
    }
    componentDidMount() {
        getAssetsInfo()
            .then((response) => {
                console.log("response", response);
                if (response.length == 0) {
                    this.setState({
                        Add: true
                    })
                }

                this.setState({
                    Add: false,
                    teamName: response[0].teamName,
                    teamLogo: response[0].teamLogoURL,
                    // teamLogo:response[0].teamLogo,

                    stadiumSeatingImage: response[0].stadiumSeatingImage,
                    lightShowFile: response[0].lightShowFile,


                    teamHex1: response[0].teamHex1,
                    teamHex2: response[0].teamHex2,
                    teamid: response[0].id,
                    teamLogoName: response[0].teamLogoName
                });
                document.querySelector('input[id=colorOne').value = this.state.teamHex1;
                document.querySelector('input[id=colorTwo').value = this.state.teamHex2;
            })
            .catch((error) => {
                console.log(error);
            });
    }
    onCreated(event) {
        const cpElem = document.querySelector("[id=" + CSS.escape(event) + "]").nextElementSibling;
        // const cpElem = this.colorPicker.element.nextElementSibling;
        cpElem.insertBefore(document.querySelector("[id=" + CSS.escape(event) + "]"), cpElem.children[2]);
        console.log('====================================', cpElem.insertBefore(document.querySelector("[id=" + CSS.escape(event) + "]"), cpElem.children[2]))
        console.log("VALUE IS ", cpElem)
        console.log('====================================')
    }
    /************************************************************************************************************************** */
    ////submit

    handleChange(event) {
        this.setState({ value: event.target.value });
    }
    ClearAll() {
        this.setState({
            teamName: '',
            teamLogo: '',
            teamHex1: '',
            teamHex2: '',
            teamLogoName: ''
        });
        document.querySelector('input[id=colorOne').value = "0B0B0B";
        document.querySelector('input[id=colorTwo').value = "0B0B0B";
    }
    // handleSubmit(event) {
    //     // alert('A name was submitted: ' + this.state.value);
    //     event.preventDefault();
    // }


    //************************************************************************************************************************************ */
    //submit

    // handleToggle = () => {
    handleSubmit(event, type) {
        try {
            // this.setState({ openNote: !this.state.openNote });

            if (
                this.state.teamName !== '' || this.state.teamLogo !== '' ||
                // this.state.stadiumSeatingImage !== '' || this.state.lightShowFile !== '' ||
                this.state.teamHex1 !== '' || this.state.teamHex2 !== '') {
                const data = {

                    // need userId to send data to firebase

                    teamName: this.state.teamName,
                    teamLogo: this.state.teamLogo,

                    // stadiumSeatingImage: this.state.stadiumSeatingImage,
                    // lightShowFile: this.state.lightShowFile,


                    teamHex1: this.state.teamHex1,
                    teamHex2: this.state.teamHex2,
                    teamLogoName: this.state.teamLogoName
                };
                if (type == 0) {
                    generateAssetsData(data)
                        .then((response) => {
                            this.setState({
                                assetsData: response
                            })
                            setTimeout(() => {
                                this.RedirectUser()
                                // window.location.href = "/dataGenerate"
                            }, 500);
                        })

                        .catch((err) => {
                            console.log(err);
                        })
                }
                if (type == 1) {
                    Updateasset(this.state.teamid, data)
                        .then((response) => {
                            this.setState({
                                assetsData: response
                            })
                            setTimeout(() => {
                                this.RedirectUser()
                                 window.location.href = "/eventScreen"
                            }, 500);
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                }

            }
        } catch (err) {
            console.log("error at handleToggle in generatingData");
        }
    };


    RedirectUser = () => {
        this.props.history.push("/AssetsPage");
    };

    handleChangeComplete = (color) => {
        this.setState({ background: color.hex });
    };

    /********************************************************************************************************************************* */
    //colorpicker

    // onCreated() {
    //     const cpElem = this.colorPicker.element.nextElementSibling;
    //     cpElem.insertBefore(this.colorPicker.element, cpElem.children[2]);
    //     console.log('====================================', cpElem.insertBefore(this.colorPicker.element, cpElem.children[2]))
    //     console.log("VALUE IS ", cpElem)
    //     console.log('====================================')
    // }

    /**************************************************************************************************************************************** */


    handleteamName = evt => {
        try {
            this.setState({ teamName: evt.target.value });
        } catch (err) {
            console.log("error at handling teamName in assets");
        }
    };

    handleteamLogo = evt => {
        try {
            this.setState({ teamLogo: evt.target.value });
        } catch (err) {
            console.log("error at handling teamLogo in assets");
        }
    };



    handlestadiumSeatingImage = evt => {
        try {
            this.setState({
                stadiumSeatingImage: evt.target.value
            })
        } catch (err) {
            console.log("error at handling stadiumSeatingImage in assets");

        }
    }


    handlelightShowFile = evt => {
        try {
            this.setState({
                lightShowFile: evt.target.value
            })
        } catch (err) {
            console.log("error at handling lightShowFile in assets");

        }
    }






    handleteamHex1 = evt => {
        try {
            this.setState({ teamHex1: evt.target.value });
        } catch (err) {
            console.log("error at handling teamHex1 in dataGeneration");
        }
    };
    removeMe = () => {
        this.setState({
            teamLogoName: ''
        })
        document.querySelector('img[id=abc]').src = "";
    }
    getName = evt => {
        if (document.querySelector('input[id=asset]').files[0]) {
            this.setState({
                teamLogoName: document.querySelector('input[id=asset]').files[0].name
            })
        }
    }
    handleteamHex2 = evt => {
        try {
            this.setState({ teamHex2: evt.target.value });
        } catch (err) {
            console.log("error at handling teamHex2 in dataGeneration");
        }
    };


    render() {


        const { classes } = this.props;
        const slidingCards = this.state.slideCards ? "afterSlide" : "beforeSlide";


        return (
            <MuiThemeProvider theme={theme} location={this.props.location}>


                <div className={classes.root}>

                    <div className={slidingCards} id={slidingCards}>

                        <div>
                            <TopBar
                                slideCards={this.slideCards}
                                props={this.props}
                                notePropsToApp={this.handleCardStyle}
                                handleNavigation={this.handleNavigation}
                            />
                        </div>
                    </div>



                    <div style={{ margin: '20px', position: 'absolute', top: '60px', left: '160px'  }}>

                        <h4 style={{ textDecorationLine: 'underline' }}>Team Information :</h4>


                        <section class="sectionClass">

                            <div class="container-fluid">
                                <div class="row sectRow">

                                    <div class="col-md-4 col-sm-12" style={{}} >

                                        <div style={{ margin: '10px' }} >
                                            <label style={{ fontWeight: 'bold' }}>Team Name: </label>
                                        </div>

                                        <div style={{ margin: '10px' }}>
                                            <label style={{ fontWeight: 'bold', }}>Team Logo : </label>
                                        </div>


                                        <div style={{ marginTop: '15px', margin: '10px' }} >
                                            <label style={{ fontWeight: 'bold' }}>Team 1 Primary Color Hex: </label>
                                        </div>

                                        <div style={{ marginTop: '15px', margin: '10px' }}>
                                            <label style={{ fontWeight: 'bold' }} >Team 1 Secondary Color Hex: </label>
                                        </div>

                                    </div>


                                    <div class="col-md-8 col-sm-12">

                                        <div>
                                            <Input
                                                // disableUnderline={true}
                                                style={{}}
                                                value={this.state.teamName}
                                                onChange={this.handleteamName}
                                            />
                                        </div>
                                        {/*************************************************************************************************************************** */}



                                        <div style={{  flexDirection: 'row', margin: '5px' }}>
                                            <label
                                                for="asset"
                                                className="MyButton"
                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                     onMouseLeave={this.getName}>Upload Image</label>
                                            <label className="setMyPadding">{this.state.teamLogoName}</label>
                                           

                                           
                                            <div style={{display:'inline-block'}}>
                                                <img id="abc" src={this.state.teamLogoURL || this.state.teamLogo}
                                                    style={{ marginRight: '10px', width: '30px', height: '30px' }}
                                                    alt="" //teamLogo
                                                />
                                            </div>
                                            <label style={{ marginBottom: "0", verticalAlign: "middle" }}>{this.state.teamLogoName ? <FaTrash className='faTrashDel' style={{ cursor: "pointer" }} onClick={this.removeMe} /> : null}</label>

                                            <input id="asset" style={{ visibility: 'hidden',width:'2%' }} type="file"></input>
                                            {/* <input id="asset" style={{ visibility: 'hidden' }} type="file"></input> */}




                                        </div>


                                        {/****************************stadium******************************************************************************************* */}

                                        {/* <div style={{ display: 'flex', flexDirection: 'row', margin: '5px' }}>
                                            <label for="stadium" className="MyButton">Upload Image</label>
                                            <input id="stadium" style={{ visibility: 'hidden' }} type="file"></input>
                                            <div>
                                                <img src={this.state.team1LogoURL}
                                                    width="50" height="50"
                                                    alt="" //stadiumseatingImage
                                                />
                                            </div>

                                        </div> */}


                                        <div style={{ display: 'flex', flexDirection: 'row', margin: '5px' }}>
                       

                                            {/* <div>
                                                <img src={this.state.teamLogo}
                                                    width="50" height="50"
                                                    alt="" //teamLogo
                                                     />
                                            </div> */}

                                        </div>



                                        {/****************************LIGHTSHOW********************************************************************************************************* */}


                                        {/* <div style={{ display: 'flex', flexDirection: 'row', margin: '5px' }}>
                                            <label for="LightShow" className="MyButton">Upload File</label>
                                            <input id="LightShow" style={{ visibility: 'hidden' }} type="file"></input>
                                            <div>
                                                <img src={this.state.team1LogoURL} 
                                                width="50" height="50" 
                                                alt="" //lightShowFile

                                                />
                                            </div>
                                        </div> */}



                                        {/* <div style={{ display: 'flex', flexDirection: 'row', margin: '5px' }}>
                                            <label
                                                for="asset"
                                                className="MyButton"
                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}

                                                onMouseLeave={this.getName}>Upload Image</label>
                                            <label className="setMyPadding">{this.state.lightShowFile}</label>
                                            {this.state.lightShowFile ? <FaTrash onClick={this.removeMe} /> : null}

                                            <input id="asset" style={{ visibility: 'hidden' }} type="file"></input>
                                            <img src={this.state.lightShowFile}
                                                width='10px' height="10px"
                                                alt=''
                                            />

                                        </div> */}




                                        {/************************************HEX COLORS******************************************************************************************* */}

                                        <div style={{ margin: '5px', display: "block", clear: "both" }}>
                                            <input id="colorOne" className="jscolor ColorPickerStyle" style={{ backgroundColor: this.state.teamHex1 ? '#' + this.state.teamHex1 : this.state.teamHex1, padding: '7' }} onBlur={this.handleteamHex1}></input>

                                        </div>

                                        <div style={{ margin: '5px' , display: "block", clear: "both"}} >
                                            <input id="colorTwo" className="jscolor ColorPickerStyle" style={{ backgroundColor: this.state.teamHex2 ? '#' + this.state.teamHex2 : this.state.teamHex2, padding: '7' }} onBlur={this.handleteamHex2} ></input>

                                        </div>


                                    </div>
                                </div>
                            </div>

                        </section>



                        <Button
                            // id="CloseButtonNote"
                            type="submit"
                            onClick={(event) => this.ClearAll()}
                            // onClick={this.props.history.push('/eventsPage')}
                            className="ButtonStyle"
                        >  Cancel </Button>
                        <Button
                            // id="CloseButtonNote"
                            type="submit"
                            onClick={(event) => this.handleSubmit(event, 0)}
                            style={{ visibility: this.state.Add ? 'visible' : 'hidden' }}
                            // onClick={this.props.history.push('/eventsPage')}
                            className="ButtonStyle"
                        >  Add </Button>
                        <Button
                            // id="CloseButtonNote"
                            type="submit"
                            onClick={(event) => this.handleSubmit(event, 1)}
                            style={{ visibility: this.state.Add ? 'hidden' : 'visible', marginLeft: '-9%' }}
                            // onClick={this.props.history.push('/eventsPage')}
                            className="ButtonStyle"
                        >  Save </Button>


                    </div>

                </div>

            </MuiThemeProvider>
        )
    }
}

export default withStyles({ withTheme: true })(AssetsPage);


//    {/* <form className="SetMyFormRight" action="javascript:void(0)">
//                                 <label style={{ fontWeight: 'bold' }}>Team Information

//                                             </label>
//                                             <h3>Team Information :</h3>
//                                             <div className="setRightStyle">Team Name:
//                                             </div>
//                                             <Input
//                                                 className="eventName"
//                                                 disableUnderline={true}
//                                                 id="eventName"
//                                                 style={{ marginBottom: 10 }}
//                                                 value={this.state.teamName}
//                                                 onChange={this.handleteamName}
//                                             />

//                                             <br></br>
//                                         <div className="setRightStyle">Team Logo
//                                             {/* <Input
//                                                 className="eventName"
//                                                 disableUnderline={true}
//                                                 id="eventName"
//                                                 style={{ marginBottom:10 }}
//                                                 value={this.state.teamLogo}
//                                                 onChange={this.handleteamLogo}
//                                             /> }
//                                             </div>
//                                             <label for="asset" className="MyButton" onMouseLeave={this.getName}>Upload Image</label>
//                                             <label className="setMyPadding">{this.state.teamLogoName}</label>
//                                             { this.state.teamLogoName ? <FaTrash onClick={this.removeMe}/>  : null }

//                                              <input id="asset" style={{visibility:'hidden'}}  type="file"></input>


//                                             <br></br>

//                                             <div className="setRightStyle">Stadium Seating Image:
//                                             </div>
//                                             <label for="stadium" className="MyButton">Upload Image</label>
//                                             <input id="stadium" style={{visibility:'hidden'}} type="file"></input>


//                                             <br></br>
//                                           <div className="setRightStyle">Light Show File:
//                                           </div>
//                                           <label for="LightShow" className="MyButton">Upload File</label>
//                                             <input id="LightShow" style={{visibility:'hidden'}} type="file"></input>


//                                             <br></br>
//                                          <div className="setRightStyle">Team Primary Color Hex: 
//                                          </div>
//                                          <input id="colorOne" className="jscolor"  style={{ backgroundColor: this.state.teamHex1 ? '#'+this.state.teamHex1 : this.state.teamHex1, padding:'7'}}  onBlur={this.handleteamHex1}></input>
//                                          {/* document.querySelector('input[id=colorOne').style.backgroundColor= 
//                                             <br></br>

//                                             <div className="setRightStyle LastHex">Team Secondary Color Hex:
//                                             </div>
//                                             <input id="colorTwo" className="jscolor" style={{ backgroundColor: this.state.teamHex2 ? '#'+this.state.teamHex2 : this.state.teamHex2,  padding:'7'}} onBlur={this.handleteamHex2} ></input>


//                                                  <br></br> */}